import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { FlexDiv, H1, P } from 'components/generic/HomePageComponents'

const Reviews = ({
  data: { header, subHeader, bodyText, author, location, backgroundImage },
  wave,
}) => {
  const imageUrl = `url(${backgroundImage})`
  return (
    <FlexDiv
      flexDirection='column'
      alignItems='center'
      backgroundImage={imageUrl}
      backgroundColor='#c2dc7e'
      backgroundRepeat='no-repeat'
      backgroundPosition='center'
      backgroundSize='cover'
      width='100%'
      padding='100px 0'
    >
      <FlexDiv
        flexDirection='column'
        maxWidth='1080px'
        marginLeft='30px'
        marginRight='30px'
        alignItems='center'
      >
        <P mt='50px'>{header}</P>
        <GenericLazyLoadImage src={wave} width='60px' />
        <H1 color='white' mb='0px' textAlign='center'>
          {subHeader}
        </H1>
        <P maxWidth='80%' textAlign='center' mb='10px'>
          {bodyText}
        </P>
        <P mb='0px'>{author}</P>
        <P mt='0px'>{location}</P>
      </FlexDiv>
    </FlexDiv>
  )
}
export default Reviews
